export default __webpack_public_path__ + "static/media/laravel.be23efbf.png";